import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconModified } from 'src/assets/icons/Modified';
import { CustomIconButton } from 'src/components/CustomIconButton';
import { TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { TruncatedTypography } from 'src/components/TruncatedTypography';

import { InsightBox } from '../InsightBox';

import { EmptyBanner } from './components/EmptyBanner';
import { SuccessMessage } from './components/SuccessMessage';
import { ToneOfVoiceInsightsItem } from './components/ToneOfVoiceInsightsItem';
import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  toneOfVoiceInsights: PropTypes.arrayOf(
    PropTypes.shape({
      classification: PropTypes.bool.isRequired,
      reason: PropTypes.string.isRequired,
      trait: PropTypes.shape({
        trait: PropTypes.string.isRequired,
        butNot: PropTypes.string,
      }),
    })
  ),
  onSettingsClick: PropTypes.func,
  onEmptyTovClick: PropTypes.func,
  analyzerToneOfVoice: PropTypes.shape({
    name: PropTypes.string.isRequired,
    traits: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  availableTovCount: PropTypes.number,
  loading: PropTypes.bool,
  onApplyToneOfVoice: PropTypes.func,
  applyingAnalyzedToneOfVoice: PropTypes.string,
  brandVoiceExistForLanguage: PropTypes.bool,
  language: PropTypes.string,
  readOnly: PropTypes.bool,
};

const defaultProps = {
  className: null,
  classes: null,
  onSettingsClick: null,
  onEmptyTovClick: null,
  toneOfVoiceInsights: [],
  analyzerToneOfVoice: null,
  availableTovCount: 0,
  loading: false,
  onApplyToneOfVoice: null,
  applyingAnalyzedToneOfVoice: null,
  brandVoiceExistForLanguage: false,
  language: null,
  readOnly: false,
};

export const ToneOfVoice = ({
  className,
  classes,
  toneOfVoiceInsights,
  onSettingsClick,
  onEmptyTovClick,
  analyzerToneOfVoice,
  availableTovCount,
  loading,
  onApplyToneOfVoice,
  applyingAnalyzedToneOfVoice,
  brandVoiceExistForLanguage,
  language,
  readOnly,
}) => {
  const styles = useStyles({ classes });

  const toneOfVoiceInsightsExist = toneOfVoiceInsights?.length > 0;

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.header}>
        <TruncatedTypography
          className={styles.boxGroupTitle}
          variant={TYPOGRAPHY_VARIANT.medium12}
          title={analyzerToneOfVoice?.name}
        >
          Tone of voice
          {analyzerToneOfVoice && <span>: {analyzerToneOfVoice.name}</span>}
        </TruncatedTypography>
        {availableTovCount > 0 && (
          <CustomIconButton
            className={styles.buttonSettings}
            onClick={onSettingsClick}
          >
            <IconModified />
          </CustomIconButton>
        )}
      </div>

      <InsightBox
        className={styles.wrapper}
        loading={loading}
      >
        {analyzerToneOfVoice &&
          (analyzerToneOfVoice?.traits || []).length > 0 &&
          !toneOfVoiceInsightsExist && (
            <SuccessMessage
              analyzerToneOfVoice={analyzerToneOfVoice}
              onSettingsClick={onSettingsClick}
            />
          )}
        {analyzerToneOfVoice && toneOfVoiceInsightsExist ? (
          toneOfVoiceInsights.map((item, index) => (
            <ToneOfVoiceInsightsItem
              key={`${item.reason}_${index}`}
              item={item}
              onApplyToneOfVoice={onApplyToneOfVoice}
              analyzerToneOfVoice={analyzerToneOfVoice}
              applyingAnalyzedToneOfVoice={applyingAnalyzedToneOfVoice}
              readOnly={readOnly}
            />
          ))
        ) : (
          <EmptyBanner
            onCtaClick={onEmptyTovClick}
            analyzerToneOfVoice={analyzerToneOfVoice}
            onSettingsClick={onSettingsClick}
            brandVoiceExistForLanguage={brandVoiceExistForLanguage}
            language={language}
          />
        )}
      </InsightBox>
    </div>
  );
};

ToneOfVoice.propTypes = propTypes;
ToneOfVoice.defaultProps = defaultProps;
